import React from "react";
import renderHTML from "react-render-html";
import _get from "lodash-es/get";
import {
  CameraHoc,
  VideoIcon2Hoc,
  Audio2Hoc,
  ChatAudioRecorderDarkHoc,
  ContactHoc,
  LocationHoc,
  IconMissedCallAudioHoc,
  IconMissedCallVideoHoc,
  RecentDeletedMessageHoc,
  DocumentIconHoc,
  SingleChatAvatarImg,
  GroupChatAvatarImg,
  ChatMuteHoc,
  RecentAudioCallHoc,
  RecentVideoCallHoc,
  AudioOffHoc,
  AudioOnHoc,
  RecentCallHangupHoc,
} from "../../../assets/images";
import {
  getFormatPhoneNumber,
  getFormattedRecentChatText,
  getHighlightedText,
  capitalizeFirstLetter,
  isAppOnline,
  capitalizeTxt,
  // shouldHideNotification,
  sendNotification,
} from "../../../Helpers/Utility";
import {
  convertUTCTOLocalTimeStamp,
  formatChatDateTime,
} from "../WebChatTimeStamp.js";
import Message from "./Message.js";
import {
  getContactNameFromRoster,
  getDataFromRoster,
  initialNameHandle,
  isLocalUser,
} from "../../../Helpers/Chat/User";
import {
  GROUP_CHAT_PROFILE_UPDATED_NOTIFY,
  THIS_MESSAGE_WAS_DELETED,
  YOU_DELETED_THIS_MESSAGE,
} from "../../../Helpers/Chat/Constant";
import ProfileImage from "../../Common/ProfileImage";
import { useSelector } from "react-redux";
import { addActiveChatData } from "../../../Redux/feature/activeChatDataSlice";
import { store } from "../../../Redux/store"; 
import { updateReadStatus } from "../../../Redux/feature/unreadCountSlice";
import { updateMsgSeenStatus } from "../Common/createMessage";
import { formatUserIdToJid, isActiveConversationUserOrGroup, isTextMessage, notificationMessageType } from "../../../Helpers/Chat/ChatHelper";
import { groupstatus } from "../../../Helpers/Chat/RecentChat";
import CustomIcon from "../../../assets/images/CustomIcon";
import { addOfflinePendingData } from "../../../Redux/feature/offlinePendingSlice";
import { getFromLocalStorageAndDecrypt } from "../../../Helpers/Chat/webChatEncryptDecrypt";
import browserTab from "../../../Helpers/Browser/BrowserTab";
import IndexedDb from "../../../Helpers/IndexedDb";
import { disconnectCallConnection } from "../../../Helpers/Call/Call";
import { muteLocalAudio } from "../../../callback";
import { addIsMuteListner } from "../../../Redux/feature/calllogsDataSlice";
import SDK from "../../../SDK";

const RecentChatItem = (props = {}) => {
  const storeSelctore = useSelector((state) => state);
  const {vCardData, unreadCountData:{ data:unreadData = [] },dynamicIcon={},chatConversationHistory,callLogData : { data:callLog = {}} } = storeSelctore
  const {
    mf_Camera,mf_VideoIcon2,mf_Audio2,mf_ChatAudioRecorderDark,mf_DocumentIcon,mf_Contact,mf_Location,mf_IconMissedCallAudio,mf_IconMissedCallVideo,mf_RecentDeletedMessage
  }=dynamicIcon?.data
  const  { callAudioMute = false  } = callLog;
  const {
    item = {},
    searchTerm,
    messageId,
    callUserJID = '',
    hidden,
    callStatus,
    isAdminBlocked = false,
    pageType = "",
    vCardData: { data: { fromUser } = {} } = {},
    item: {
      roster: { image, groupImage,thumbImage } = {},
      recent: {
        createdAt,
        msgStatus,
        fromUserId,
        msgType,
        deleteStatus,
        chatType,
        muteStatus
      } = {},
    } = {},
    handlePopupState
  } = props;
 
  const [recentChatItemState, setRecentChatItemState] = React.useState({
    image: null,
    showModal: false,
    recentDrop: false,
    pinChat: false,
    archiveChat: false,
    isArchive: true,
    needToImplement: false,
    unreadCount:0
  });
  let audio =  window.busySignal;

  React.useEffect(()=>{
    if(unreadData){
      const count = unreadData.find((ele)=> ele.fromUserId === fromUserId)?.unreadCount || 0
      setRecentChatItemState({
        ...recentChatItemState,
        unreadCount:count
      })
    }
  },[unreadData])

  React.useEffect(()=>{
    const initialNotifi = Object.entries(chatConversationHistory?.data).length > 0
    if(initialNotifi && item.recent.msgStatus !== 2){
        const messageFromUser = vCardData?.data?.fromUser;
      if (!isLocalUser(item.recent.publisherId)) {
        const webSettings = getFromLocalStorageAndDecrypt("websettings");
        let parserLocalStorage = webSettings ? JSON.parse(webSettings) : {};
        const { Notifications = true } = parserLocalStorage;
        const pendingMessages = storeSelctore?.chatSeenPendingMsgData?.data || [];
        if (!isActiveConversationUserOrGroup(fromUserId, chatType) || !browserTab.data) {
          const recentChat = item;
          if (msgType && typeof item.recent.msgId === "string" && notificationMessageType.indexOf(item.recent.msgBody) < 0 && pendingMessages.length !== 0) {
            const {
              recent: { NotificationTo }
            } = recentChat;
            if (NotificationTo !== messageFromUser && item.recent.msgBody === "2") {
              return;
            }
            Notifications && item.recent.muteStatus === 0 && item.recent.archiveStatus !== 1 && createPushNotification(recentChat);
          } else {
            /**
            // Notifications && item.recent.muteStatus === 0 && item.recent.archiveStatus !== 1 && createPushNotification(recentChat);
            */
          }
        }
      }
    }
  },[messageId])
  
  const getContactName = () => {
    return getContactNameFromRoster(item.roster);
  };

  const formatMessage = (msgBody, msgTypeFormatter) => {
    let message = msgBody.message;
    if (
      ["image", "video", "audio", "file", "contact", "location"].indexOf(
        msgTypeFormatter
      ) > -1
    ) {
      // Media type icon mapping
      const icons = {
        image: (
          <i className="chat-camera">
             <CustomIcon icon={mf_Camera ? mf_Camera : <CameraHoc  viewBox="0 0 20 20"/>} {...props} />
          </i>
        ),
        video: (
          <i className="chat-video">
            <CustomIcon
              icon={mf_VideoIcon2 ? mf_VideoIcon2 : <VideoIcon2Hoc viewBox="0 0 20 20"/>}
              {...props}
            />
          </i>
        ),
        audio: (
          <i
            className={` ${
              _get(msgBody, "media.audioType", "") !== "recording"
                ? "audio"
                : "mic"
            } chat-audio`}
          >
            {_get(msgBody, "media.audioType", "") !== "recording" ? (
          <CustomIcon icon={mf_Audio2 ? mf_Audio2 : <Audio2Hoc viewBox=" 0 0 20 20" />} {...props} />
        ) : (
          <CustomIcon
          icon={
            mf_ChatAudioRecorderDark ? (
              mf_ChatAudioRecorderDark
            ) : (
              <ChatAudioRecorderDarkHoc viewBox="0 0 13.249 19.873"/>
            )
          }
          {...props}
        />
        )}
          </i>
        ),
        file: (
          <i className="chat-docu">
          <CustomIcon
            icon={mf_DocumentIcon ? mf_DocumentIcon : <DocumentIconHoc viewBox="0 0 20 20"/>}
            {...props}
          />
          </i>
        ),
        contact: (
          <i className="chat-contact">
            <CustomIcon icon={mf_Contact ? mf_Contact : <ContactHoc />} {...props} />
          </i>
        ),
        location: (
          <i className="chat-location">
            <CustomIcon icon={mf_Location ? mf_Location : <LocationHoc />} {...props} />
          </i>
        ),
        missedCallAudio: (
          <i className="chat-missedcall">
            <CustomIcon
              icon={
                mf_IconMissedCallAudio ? (
                  mf_IconMissedCallAudio
                ) : (
                  <IconMissedCallAudioHoc />
                )
              }
              {...props}
            />
          </i>
        ),
        missedCallVideo: (
          <i className="chat-missedcall">
            <CustomIcon
              icon={
                mf_IconMissedCallVideo ? (
                  mf_IconMissedCallVideo
                ) : (
                  <IconMissedCallVideoHoc />
                )
              }
              {...props}
            />
          </i>
        ),
      };
      message =
        msgBody && typeof msgBody === "object" && msgBody.media
          ? msgBody.media.caption
          : undefined;
      message =
        message ||
        (msgTypeFormatter === "image" ? "Photo" : capitalizeFirstLetter(msgTypeFormatter));
      message = renderHTML(getFormattedRecentChatText(message));
      return (
        <>
          {icons[msgTypeFormatter] || ""} {message}
        </>
      );
    }
    return renderHTML(getFormattedRecentChatText(message));
  };

  const getDeletedText = (publisherIdText) =>
    isLocalUser(publisherIdText) ? (
      <span className="text-italic innerSpan">{YOU_DELETED_THIS_MESSAGE}</span>
    ) : (
      <span className="text-italic innerSpan">{THIS_MESSAGE_WAS_DELETED}</span>
    );

  /**
   * handleLastMessage function is to handle the last message publisher name along with last message.
   */
  const handleLastMessage = (data) => {
    const {
      recent: { chatType:chatTypeLastMsg, publisherId, msgBody, msgType:msgTypeLastMsg },
    } = data;
    const conditionArray = [
      { condition: "groupchat" },
      { condition: "broadcast" },
    ];
    const condionCheck = conditionArray.some(
      (ele) => ele.condition === chatTypeLastMsg
    );
    if (condionCheck) {
      if (publisherId !== fromUser) {
        const senderDetails = getDataFromRoster(publisherId);
        if (senderDetails) {
          const lastMessageBy = getContactNameFromRoster(senderDetails);
          const lastMessageFormat = formatMessage(msgBody, msgTypeLastMsg);
          return (
            <React.Fragment>
              {lastMessageBy && !isLocalUser(publisherId) && (
                <span className="groupLastMessageBy">{lastMessageBy}: </span>
              )}
              {lastMessageFormat && (
                <span className="groupLastMessage">
                  {_get(props, "item.recent.deleteStatus", 0) === 1
                    ? THIS_MESSAGE_WAS_DELETED
                    : lastMessageFormat}
                </span>
              )}
            </React.Fragment>
          );
        }
        const unknownPublisher =
          senderDetails && senderDetails.mobileNumber
            ? getFormatPhoneNumber(senderDetails.mobileNumber)
            : publisherId;
        return (
          <React.Fragment>
            {unknownPublisher && (
              <span className="groupLastMessageBy">{unknownPublisher}: </span>
            )}
            <span className="groupLastMessage">
              {formatMessage(msgBody, msgTypeLastMsg)}{" "}
            </span>
          </React.Fragment>
        );
      }
    }
    return _get(props, "item.recent.deleteStatus", 0) === 1 ? (
      <>
        <i className="recallMsgIcon">
          <CustomIcon
            icon={
              mf_RecentDeletedMessage ? (
                mf_RecentDeletedMessage
              ) : (
                <RecentDeletedMessageHoc viewBox="0 0 18 18"/>
              )
            }
            {...props}
        />
        </i>
        {getDeletedText(publisherId)}
      </>
    ) : (
      formatMessage(msgBody, msgTypeLastMsg)
    );
  };

  const stopAudio = () => {
    audio.loop = false;
    audio.pause();
    audio.currentTime = 0;
  }

  const handleToggleHangUpCall = () => {
    stopAudio();
    disconnectCallConnection(); //hangUp calls
  };

  /**
   * handleMessageType method to handle the last message type icon in recent chat section.
   * @param {object} item
   */
  const groupNotification = (itemGrpNotify) => {
      const {
        rosterData: { data }
      } = storeSelctore;
      const {
        recent: { publisherId, userId:userIdGrpNotify, profileUpdatedStatus, chatType:chatTypeGrpNotify }
      } = itemGrpNotify;
      return groupstatus(publisherId, userIdGrpNotify, profileUpdatedStatus, data, chatTypeGrpNotify);
    };

  const handleMessageType = (itemMsgType) => {
    if (item.recent.msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY) {
      return groupNotification(item);
    }
    switch (itemMsgType.recent.msgType) {
      case "text":
      case "auto_text":
      case "image":
      case "video":
      case "audio":
      case "file":
      case "contact":
      case "location":
        return handleLastMessage(item);
      default:
        return null;
    }
  };

  const handleToggleMute = async () => {
    const audioMuteResult = await SDK.muteAudio(!callAudioMute);
    if (audioMuteResult?.statusCode === 200) {
      muteLocalAudio(!callAudioMute);
      store.dispatch(addIsMuteListner(!callAudioMute));
    }
  };

  /**
   * handleTimeStamp() method to manage the message time format.
   * @param {object} response
   */
  const handleTimeStamp = (time) => {
    return formatChatDateTime(convertUTCTOLocalTimeStamp(time), "recent-chat");
  };

  /**
   * clickListener() method to dispatch the action with contact info payload.
   * In this method, to perform display the conversation header section.
   * @param {object} event
   * @param {object} response
   */

  const clickListener = async(e, response) => {
    const { recent : { chatType:chatTypeClickListener="" } , roster: { userId:userIdClickListener = "",userJid="",groupId:groupIdClickListener="" } } = response
    const { chatConversationHistory:{ data:chatConversationHistoryData = {} }={},
      unreadCountData:{data:unreadCountData} 
    } = store.getState()
    handlePopupState(true)
    const chatId= chatTypeClickListener !== "groupchat" ?  userIdClickListener : groupIdClickListener
    const chatJid = chatTypeClickListener !== "groupchat" ?  userJid : formatUserIdToJid(groupIdClickListener)
    const recordingStatus = getFromLocalStorageAndDecrypt("recordingStatus");
    if (recordingStatus === false) return;
    let data = {
      "chatId" : chatId,
      "chatJid" : chatJid,
      "chatType" : chatTypeClickListener,
      "recent": response?.recent,
      "roster": response?.roster,
    }
    store.dispatch(addActiveChatData(data))
    store.dispatch(updateReadStatus(chatId))
    if(!isAppOnline){
      const offlineMsgObj = {
        chatId,chatConversationHistoryData:chatConversationHistoryData[chatId]
      }
      const unreadFlag = unreadCountData.find((ele)=>(ele.fromUserId === chatId))?.unreadCount
      unreadFlag !== 0 && store.dispatch(addOfflinePendingData(offlineMsgObj))
    }else{
      updateMsgSeenStatus();
    }
  };

  const createPushNotification = (recentChat) => {
    try {
      const {
        recent: {
          // chatType,
          msgBody: { message_type, message },
          publisherId,
          // fromUserId
        },
        // roster: { image, groupImage }
      } = recentChat;
      const localDb = new IndexedDb();
      const messageBody = isTextMessage(message_type) ? message : `${capitalizeTxt(message_type || "")}`;
      let updateMessage = message_type ? messageBody : handleMessageType(recentChat);
      let updateDisplayName, imageToken;

      if (chatType === "chat") {
        
        updateDisplayName = getsenderName(recentChat.roster);
        imageToken = thumbImage !== "" ? thumbImage : image;
      } else {
        updateDisplayName = getContactName();
        imageToken = thumbImage !== "" ? thumbImage : groupImage;
        const senderName = getContactNameFromRoster(getDataFromRoster(publisherId)) || publisherId;
        if (message_type) updateMessage = `${senderName}: ${updateMessage}`;
      }      

      /**
      // const {
      //   unreadCountData: { unreadDataObj }
      // } = props;
      // let totalChats = 0;
      // let totalCounts = 0;
      // Object.entries(unreadData).map(unreads => {
      //   if(unreads[1].unreadCount !== 0){
      //     let count = unreads[1].unreadCount;
      //     totalChats++;
      //     totalCounts = totalCounts + count;
      //   }
      // })
      // if (shouldHideNotification() && browserNotify.isPageHidden) {      
      //   updateDisplayName = "You have " + (totalChats - 1) +" new chat" + ((totalChats > 1) ? "s" : "");
      //   updateMessage = "Total " + (totalCounts - 1) + " unread message" + ((totalCounts > 1) ? "s" : "");
      // }
      */
      localDb
        .getImageByKey(imageToken, "profileimages")
        .then((blob) => {
          let blobUrl = window.URL.createObjectURL(blob);
          /**
          // if (shouldHideNotification() && browserNotify.isPageHidden) {
          //   blobUrl = "";
          // }
          */
          sendNotification(updateDisplayName, blobUrl, updateMessage, fromUserId);
        })
        .catch((err) => {
          let avatarImage = chatType === "chat" ? SingleChatAvatarImg : GroupChatAvatarImg;
          /**
          // if (shouldHideNotification() && browserNotify.isPageHidden) {
          //   avatarImage = "";
          // }
          */
          sendNotification(updateDisplayName, avatarImage, updateMessage, fromUserId);
        });
    } catch (error) { }
  };

  const getsenderName = (contactDetails) => {
    return getContactNameFromRoster(contactDetails);
  };

  const handleRecentChatClick = (e,itemChatClick) => {
    clickListener(e, itemChatClick)
  }
  const {
    roster: { groupId, emailId, userId },
  } = item;
  const lastMessage = handleMessageType(item);

  const messageDeliveryTime = (createdAt && handleTimeStamp(createdAt)) || null;

  const contactName = getContactName();
  const iniTail = initialNameHandle(item.roster, contactName);
  const hightlightText = contactName
    ? getHighlightedText(contactName, searchTerm)
    : fromUserId;
  if (chatType === "groupchat" && !groupId) return null;

  let selectedRoster = props.selectedRoster;
  let selectedJid = "";

  if (selectedRoster && selectedRoster.data && selectedRoster.data.roster) {
    selectedJid = selectedRoster.data.roster.userId;
    if (selectedJid === undefined) {
      selectedJid = selectedRoster.data.roster.groupId;
    }
  }
  const ongoingCallDisplayText =
  "Ongoing " +
  (props.callMode && props.callMode === "onetomany" ? "group " : " ") +
  props.callType +
  " call…";

  const activeClass = userId ? userId : groupId;
  return (
    <React.Fragment>
      <li
        style={{ display: hidden ? "none" : "" }}
        className=
        {`chat-list-li ${pageType ? "recentLiCustom" : ""} 
        ${activeClass === selectedJid ? "active" : ""} 
        ${fromUserId === callUserJID ? " activeCall" : ""} `}
        id="chat-list-id"
        data-name="list"
        data-chat-id={fromUserId}
        onClick={(e) => handleRecentChatClick(e, item)}
      >
        <ProfileImage
          chatType={chatType}
          userId={userId || groupId}
          temporary={false}
          imageToken={(isAdminBlocked ? "" : thumbImage) || (thumbImage !== '' ? thumbImage : image || groupImage)}
          emailId={emailId}
          name={iniTail}
        />
        <div className="recentchats">
          <div className="recent-username-block">
            <div className="recent-username">
              <div className="username">
                <h3 title={contactName}>{hightlightText}</h3>
              </div>
            </div>
            {lastMessage  && (
              <span
                className={
                  recentChatItemState.unreadCount && parseInt(recentChatItemState.unreadCount) !== 0
                    ? "messagetime-plus"
                    : "messagetime"
                }
              >
                {messageDeliveryTime}
              </span>
            )}
          </div>
          <div className="recent-message-block">
          {fromUserId === callUserJID && (
                <>
                  <div className="iconOnGoingCall" onClick={props.handleShowCallScreen} >
                    {props.callType === "audio" ? (
                      <i className="iconAudioCall">
                        <RecentAudioCallHoc  viewBox="0 0 11.469 11.469"/>
                      </i>
                    ) : (
                      <i className="iconvideoCall">
                        <RecentVideoCallHoc viewBox="0 0 20 12"/>
                      </i>
                    )}
                  </div>
                  <span className="callDetails" onClick={props.handleShowCallScreen}>
                    {ongoingCallDisplayText}
                  </span>
                </>
              )}
            <Message
              msgStatus={msgStatus}
              lastMessage={lastMessage}
              messageId={messageId}
              fromUserId={fromUserId}
              chatUserType={chatType}
              msgType={msgType}
              publisherId={item.recent.publisherId}
              fromUser={vCardData.data.fromUser}
              deleteStatus={deleteStatus}
            />
            <div className="recent-message-icon">
              {((muteStatus === 1 && pageType === "recent") ||
                (muteStatus === 1 && pageType === "archive" && !isPermanentArchvie)) && (
                  <i className="MuteChat">
                    <ChatMuteHoc viewBox="0 0 19 17"/>
                  </i>
              )}
              {parseInt(recentChatItemState.unreadCount) > 0  && (
                <p className="notifi">
                  {parseInt(recentChatItemState.unreadCount) > 99 ? "99+" : recentChatItemState.unreadCount}
                </p>
              )}
            </div>
          </div>
        </div>
        {fromUserId === callUserJID && (
          <div className="CallAction">
            {callStatus && callStatus.toLowerCase() === "connected" && (
              <i onClick={handleToggleMute} title="Mute/Unmute" className={callAudioMute ? "Mute" : ""}>
                {callAudioMute ? <AudioOffHoc viewBox="0 0 19.144 20.207"/> : <AudioOnHoc viewBox="0 0 10.765 14.609"/>}
              </i>
            )}
            <i title="Hangup" className="Hangup" onClick={handleToggleHangUpCall}>
              <RecentCallHangupHoc viewBox="0 0 28 28"/>
            </i>
          </div>
        )}
      </li>
    </React.Fragment>
  );
};

export default RecentChatItem;
